import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center gap-3 min-w-[448px]" }
const _hoisted_2 = { class: "w-full flex justify-center items-end" }
const _hoisted_3 = { class: "form-control grow" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "form-control pb-3 pl-10 pr-8 tooltip",
  "data-tip": "Make this configuration visible for other users"
}
const _hoisted_6 = { class: "form-control w-full" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "w-full pt-4 px-6 flex justify-center items-center gap-3 flex-wrap md:flex-nowrap" }

import { computed, ref, watch } from "vue";
import { useBackendStore } from "@/stores";
import ConfigUpDownloadButton from "@/components/config/ConfigUpDownloadButton.vue";
import ConfigDeleteButton from "@/components/config/ConfigDeleteButton.vue";
import ConfigUpdateButton from "@/components/config/ConfigUpdateButton.vue";
import ConfigNewButton from "@/components/config/ConfigNewButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigEdit',
  setup(__props) {

const backend = useBackendStore();

const configName = ref<HTMLElement | null>(null);

// Use separate refs so that it will work even when currentConfig is still null
const inputPublic = ref(backend.currentConfig?.public ?? true);
const inputName = ref("");
const inputDescription = ref(backend.currentConfig?.description ?? "");
watch(inputPublic, (v) => {
  if (backend.currentConfig != null) backend.currentConfig.public = v;
});
watch(inputName, (v) => {
  if (backend.currentConfig != null && v != "") backend.currentConfig.name = v;
});
watch(inputDescription, (v) => {
  if (backend.currentConfig != null && v != "")
    backend.currentConfig.description = v;
});

// Make sure we know which user is logged in
backend.fetchUser();

const disabled = computed(() => backend.currentConfig == null);

// Synchronize local state of public switch on new config
watch(
  () => backend.currentConfig?.id,
  () => {
    if (backend.currentConfig != null) {
      inputPublic.value = backend.currentConfig.public;
      inputDescription.value = backend.currentConfig.description;
    }
  }
);

// Synchronize value of name input field
watch(
  () => ({ id: backend.currentConfig?.id, name: backend.currentConfig?.name }),
  (newVal, old) => {
    if (configName.value == null) return;
    const configChanged = newVal.id != old.id;
    const nameChanged = newVal.name != old.name;

    if (nameChanged && !configChanged && newVal.name != undefined) {
      // Other component forced new config name, update input
      inputName.value = newVal.name;
    } else if (configChanged) {
      // Clear input when new predefined config is selected
      inputName.value = "";
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label pl-3" }, [
          _createElementVNode("span", { class: "label-text" }, "Name")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "config-name",
          ref_key: "configName",
          ref: configName,
          placeholder: "New name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputName).value = $event)),
          class: "input input-bordered w-full",
          disabled: disabled.value
        }, null, 8, _hoisted_4), [
          [_vModelText, inputName.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label mb-1" }, [
          _createElementVNode("span", { class: "label-text" }, "Public")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "toggle",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputPublic).value = $event))
        }, null, 512), [
          [_vModelCheckbox, inputPublic.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label pl-3" }, [
        _createElementVNode("span", { class: "label-text" }, "Description")
      ], -1)),
      _withDirectives(_createElementVNode("textarea", {
        class: "textarea textarea-bordered h-60",
        placeholder: "Enter description",
        disabled: disabled.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputDescription).value = $event))
      }, null, 8, _hoisted_7), [
        [_vModelText, inputDescription.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(ConfigUpDownloadButton, { class: "tour-config-updownload" }),
      _createVNode(ConfigDeleteButton),
      _createVNode(ConfigNewButton),
      _createVNode(ConfigUpdateButton)
    ])
  ]))
}
}

})